import React from "react";

import "./createPassword.scss";
import Password from "components/Password/index";

function CreatePassword({
  isReset, 
  nextStep, 
  question, 
  token, 
  email, 
  setUserData, 
  setSelectedQuestions, 
  setAnswers, 
  selectedQuestions, 
  answers, answer
}) {
  return (
    <>
      <Password question={question} answer={answer} reset={isReset} isReset={isReset} nextStep={nextStep} setUserData={setUserData} id={token} email={email} setSelectedQuestions={setSelectedQuestions} setAnswers={setAnswers} selectedQuestions={selectedQuestions} answers={answers} />
    </>
  );
}

export default CreatePassword;
